// removed by extract-text-webpack-plugin
module.exports = {"root":"credit-detail--root--3SO8euKS","counts":"credit-detail--counts--p5qfgCcN","description":"credit-detail--description--ztvozOxT","more-info":"credit-detail--more-info--371_07a0","moreInfo":"credit-detail--more-info--371_07a0"};


//////////////////
// WEBPACK FOOTER
// ./components/credit-detail/styles.css
// module id = ./components/credit-detail/styles.css
// module chunks = 0